export default "__VITE_ASSET__DRmkpdZO__"